<template>
    <div class="amTweens">
        <header class="amTweens__header">
            <h3 class="amTweens__title">
                Steps
            </h3>

            <button class="amTweens__add" type="button" @click.stop="onAdd">
                <font-awesome-icon :icon="['far', 'plus']" />
            </button>
        </header>

        <draggable
            v-if="tweensNew.length"
            v-model="tweensNew"
            :move="onMove"
            @change="onReorder"
        >
            <transition-group tag="ul" class="amTweens__list" name="tween-transition">
                <li v-for="tween in tweensNew" :key="tween.id" class="amTweens__item">
                    <animation-step :tween="tween" @input="onInput" />
                </li>
            </transition-group>
        </draggable>

        <div v-else class="amTweens__empty">
            No animation steps found.
        </div>
    </div>
</template>

<script>
import Draggable from 'vuedraggable';
import uniqid from 'uniqid';

import AnimationStep from '@/components/settings/component/animations/animation-step';
import { Tween, TweenVar } from '@/data/data-models';

export default {
    name: 'animation-steps',
    components: {
        AnimationStep,
        Draggable,
    },

    props: {
        tweens: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            tweensNew: [],
            uniqid,
        };
    },

    watch: {
        tweens() {
            this.tweensNew = this.tweens;
        },
    },

    created() {
        this.tweensNew = this.tweens;
    },

    methods: {
        onAdd() {
            const tween = new Tween({
                id: uniqid(),
                vars: [new TweenVar({ id: uniqid() })],
            });

            this.tweensNew.push(tween);
            this.$emit('update', this.tweensNew);
        },

        onMove(sortableEvt, evt) {
            if (typeof evt.target.dataset.dragHandle !== 'undefined') {
                return true;
            }

            return false;
        },

        onReorder() {
            this.$emit('update', this.tweensNew);
        },

        onInput(tween) {
            if (!tween.vars.length) {
                this.tweensNew.splice(this.tweensNew.indexOf(tween), 1);
            }

            this.$emit('input', this.tweensNew);
        },
    },
};
</script>

<style lang="scss">
.tween-transition-move {
    transition: transform 0.5s;
}

.amTweens {
    min-width: 100%;

    &__header {
        display: flex;
    }

    &__title {
        display: inline-block;
        font-size: 0.875rem;
        font-weight: 600;
        padding: 0.5em 1.25em;
        border: 1px solid var(--form-inputBorderColor);
        border-bottom: none;
        background-color: var(--app-borderColor);
    }

    &__add {
        padding: 0.25em 1em;

        &:hover {
            background-color: var(--app-hoverBackgroundColor);
        }
    }

    &__item {
        border: 1px solid var(--form-inputBorderColor);
        background-color: var(--app-hoverBackgroundColor);
    }

    &__empty {
        padding: 1em;
        color: var(--app-color);
        background-color: var(--app-hoverBackgroundColor);
        border: 1px solid var(--form-inputBorderColor);
        font-size: 0.875rem;
    }
}
</style>
